import { errorMessageFromResponse } from "../apiError";

export async function parseSigninError(
  res: Response,
  fallback = "Failed to sign in"
): Promise<string> {
  return errorMessageFromResponse(res, fallback);
}

export function presentSigninError(message: string): string {
  const normalized = (message || "").toLowerCase();
  if (normalized.includes("invalid credentials")) {
    return "Invalid email or password";
  }
  return message || "Failed to sign in";
}
